export const CLAIMED_FOR_RESPONSE = "ClaimedForResponse";
export const CLAIMED_FOR_RESPONSE_DURING_REVIEW = "ClaimedForResponseDuringReview";
export const CLAIMED_FOR_REVIEW = "ClaimedForReview";
export const CLAIMED_FOR_FORWARD_REVIEW = "ClaimedForForwardReview";
export const REPORT = "ReadyForReport";
export const REVIEW_REPORT = "ReadyForReviewReport";
export const DISAGREE_REPORT = "ReadyForDisagreeReport";
export const FORWARD = "ReadyForForward";
export const DISAGREED = "Disagreed";
export const CLAIMED_CLIENT_ACTION = "ClaimedClientAction";
export const SILENT_CLAIM_TIMEOUT = "SilentClaimTimeout";
export const CLAIMED_FOR_REVIEW_DETAILED = "ClaimedForReviewDetailed";
export const RESPOND_AS_MANAGER = "RespondAsManager";
export const REVIEW_AS_MANAGER = "ReviewAsManager";
export const REVIEW_ESCALATION_AS_MANAGER = "ReviewEscalationAsManager";
export const EDIT_META_AS_MANAGER = "EditMetaAsManager";
export const EDIT_DIALOGUE_AS_MANAGER = "EditDialogueAsManager";
export const VIEW_DIALOGUE_OPTIONS_AS_MANAGER = "ViewDialogueOptionsAsManager";
export const DETAILED_REVIEW_AS_MANAGER = "DetailedReviewAsManager";
export const QUALITY_REVIEW_AS_MANAGER = "QualityReviewAsManager";

//TODO where are these from???
export const CLAIMED_STATE = "claim";
export const UNCLAIMED_STATE = "unclaim";
export const CLOSED_STATE = "closed";
export const EXPIRED_STATE = "expired";
export const FORWARD_STATE = "forward";
export const NEW_STATE = "new";
export const QUARANTINE_STATE = "quarantine";
export const REPORT_STATE = "report";
export const RESOURCE_CACHE = "resource-cache";

//All these states mean the Expert can add dialogue to the conversation
export const MESSAGE_EDITOR_STATES = {
  [CLAIMED_FOR_RESPONSE]: CLAIMED_FOR_RESPONSE,
  [CLAIMED_FOR_RESPONSE_DURING_REVIEW]: CLAIMED_FOR_RESPONSE_DURING_REVIEW,
  [RESPOND_AS_MANAGER]: RESPOND_AS_MANAGER,
  [EDIT_META_AS_MANAGER]: EDIT_META_AS_MANAGER,
  [EDIT_DIALOGUE_AS_MANAGER]: EDIT_DIALOGUE_AS_MANAGER,
  [RESPOND_AS_MANAGER]: RESPOND_AS_MANAGER,
  [CLAIMED_CLIENT_ACTION]: CLAIMED_CLIENT_ACTION
};
export const RESPOND = "ReadyForResponse";
export const REVIEW = "ReadyForReview";
export const REPORTED = "Reported";
export const FORWARDED = "Forwarded";
export const REVIEWED = "Reviewed";
export const RESPONDED = "Responded";
export const PASSED = "Passed";
export const CLAIM_TIMEOUT = "ClaimTimeout";
export const CLOSED = "Closed";
export const BLANK = "blank";
export const CLAIMED_BY_ANOTHER = "ClaimedByAnother";
export const VIEW_AS_MANAGER = "ViewAsManager";
export const UNAVAILABLE = "Unavailable";
export const RESPOND_CLIENT_ACTION = "ReadyForClientActionResponse";
export const REVIEW_DETAILED = "ReviewDetailed";

//All these states mean the Expert can only view the conversation
export const MESSAGE_READ_ONLY_STATES = {
  [RESPOND]: RESPOND,
  [RESPONDED]: RESPONDED,
  [REVIEW]: REVIEW,
  [REVIEWED]: REVIEWED,
  [REPORTED]: REPORTED,
  [FORWARDED]: FORWARDED,
  [PASSED]: PASSED,
  [CLAIM_TIMEOUT]: CLAIM_TIMEOUT,
  [SILENT_CLAIM_TIMEOUT]: SILENT_CLAIM_TIMEOUT,
  [CLOSED]: CLOSED,
  [BLANK]: BLANK,
  [CLAIMED_BY_ANOTHER]: CLAIMED_BY_ANOTHER,
  [VIEW_AS_MANAGER]: VIEW_AS_MANAGER,
  [VIEW_DIALOGUE_OPTIONS_AS_MANAGER]: VIEW_DIALOGUE_OPTIONS_AS_MANAGER,
  [CLAIMED_FOR_REVIEW]: CLAIMED_FOR_REVIEW,
  [CLAIMED_FOR_FORWARD_REVIEW]: CLAIMED_FOR_FORWARD_REVIEW,
  [DISAGREED]: DISAGREED,
  [UNAVAILABLE]: UNAVAILABLE,
  [REVIEW_AS_MANAGER]: REVIEW_AS_MANAGER,
  [REVIEW_ESCALATION_AS_MANAGER]: REVIEW_ESCALATION_AS_MANAGER,
  [RESPOND_CLIENT_ACTION]: RESPOND_CLIENT_ACTION,
  [DETAILED_REVIEW_AS_MANAGER]: DETAILED_REVIEW_AS_MANAGER,
  [QUALITY_REVIEW_AS_MANAGER]: QUALITY_REVIEW_AS_MANAGER
};
const MESSAGE_MANAGER_ONLY_STATES = {
  [VIEW_AS_MANAGER]: VIEW_AS_MANAGER,
  [RESPOND_AS_MANAGER]: RESPOND_AS_MANAGER,
  [REVIEW_AS_MANAGER]: REVIEW_AS_MANAGER,
  [EDIT_META_AS_MANAGER]: EDIT_META_AS_MANAGER,
  [EDIT_DIALOGUE_AS_MANAGER]: EDIT_DIALOGUE_AS_MANAGER,
  [VIEW_DIALOGUE_OPTIONS_AS_MANAGER]: VIEW_DIALOGUE_OPTIONS_AS_MANAGER,
  [DETAILED_REVIEW_AS_MANAGER]: DETAILED_REVIEW_AS_MANAGER,
  [QUALITY_REVIEW_AS_MANAGER]: QUALITY_REVIEW_AS_MANAGER
};

//used exclusively for determining full screen notifications, i.e. claim timeout
const EXPERT_EDITOR_MESSAGE_STATES = {
  [CLAIMED_FOR_RESPONSE]: CLAIMED_FOR_RESPONSE,
  [CLAIMED_FOR_RESPONSE_DURING_REVIEW]: CLAIMED_FOR_RESPONSE_DURING_REVIEW,
  [CLAIMED_FOR_REVIEW]: CLAIMED_FOR_REVIEW,
  [CLAIMED_FOR_FORWARD_REVIEW]: CLAIMED_FOR_FORWARD_REVIEW,
  [DISAGREED]: DISAGREED,
  [CLAIMED_CLIENT_ACTION]: CLAIMED_CLIENT_ACTION
};
const MESSAGE_REVIEW_STATES = {
  [CLAIMED_FOR_REVIEW]: CLAIMED_FOR_REVIEW,
  [CLAIMED_FOR_FORWARD_REVIEW]: CLAIMED_FOR_FORWARD_REVIEW,
  [DISAGREED]: DISAGREED,
  [CLAIMED_FOR_REVIEW_DETAILED]: CLAIMED_FOR_REVIEW_DETAILED
};
const MESSAGE_QUALITY_REVIEW_STATES = {
  [REVIEW_DETAILED]: REVIEW_DETAILED,
  [CLAIMED_FOR_REVIEW_DETAILED]: CLAIMED_FOR_REVIEW_DETAILED,
  [QUALITY_REVIEW_AS_MANAGER]: QUALITY_REVIEW_AS_MANAGER
};
const LOCKED_STATES = [UNAVAILABLE, CLOSED, CLAIM_TIMEOUT, SILENT_CLAIM_TIMEOUT, VIEW_AS_MANAGER, EDIT_DIALOGUE_AS_MANAGER, VIEW_DIALOGUE_OPTIONS_AS_MANAGER, RESPOND_AS_MANAGER, REVIEW_AS_MANAGER, CLAIMED_CLIENT_ACTION];
const LOCKED_ALLOW_TERMINATION = [CLAIMED_CLIENT_ACTION];
const TERMINATION_ACTIONS = ["claimExpire"];

// To override the conversation footer & its actions when message in review mode - EMA
export const hasClaimedAsResponse = messageState => {
  return messageState === CLAIMED_FOR_RESPONSE;
};

// To override the conversation footer & its actions when message in review mode - EMA
export const hasClaimedAsReview = messageState => {
  return messageState === CLAIMED_FOR_REVIEW;
};

// To override the conversation footer & its actions when message in review escalate mode - EMA
export const hasClaimedAsReviewEscalate = messageState => {
  return messageState === CLAIMED_FOR_FORWARD_REVIEW || messageState === DISAGREED;
};
export const isReadOnlyState = messageState => {
  return MESSAGE_READ_ONLY_STATES[messageState] ? true : false;
};
export const isMessageEditorState = messageState => {
  return MESSAGE_EDITOR_STATES[messageState] ? true : false;
};
export const isMessageRespondedOrReviewed = messageState => {
  return !messageState || MESSAGE_READ_ONLY_STATES[messageState] === RESPOND || MESSAGE_READ_ONLY_STATES[messageState] === REVIEW || MESSAGE_READ_ONLY_STATES[messageState] === RESPONDED || MESSAGE_READ_ONLY_STATES[messageState] === REVIEWED || MESSAGE_READ_ONLY_STATES[messageState] === DISAGREED ? true : false;
};
export const isMessageManagerState = messageState => {
  return MESSAGE_MANAGER_ONLY_STATES[messageState] ? true : false;
};
export const isMessageReviewState = messageState => {
  return MESSAGE_REVIEW_STATES[messageState] ? true : false;
};
export const isExpertMessageEditorState = messageState => {
  return EXPERT_EDITOR_MESSAGE_STATES[messageState] ? true : false;
};
export const isStateLocked = (messageState, action) => {
  let isLocked = LOCKED_STATES.includes(messageState);
  if (isLocked && TERMINATION_ACTIONS.includes(action) && LOCKED_ALLOW_TERMINATION.includes(messageState)) {
    isLocked = false;
  }
  return isLocked;
};
export const isQualityReviewState = messageState => {
  return MESSAGE_QUALITY_REVIEW_STATES[messageState] ? true : false;
};